import { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

const Input = ({
  ref,
  className,
  type,
  ...props
}: InputProps & { ref?: React.Ref<HTMLInputElement> }) => {
  return (
    <input
      type={type}
      className={cn(
        'placeholder:text-muted-foreground focus-visible:ring-ring/70 bg-input-bg h-auto w-full rounded-md border-0 px-3 py-1.5 text-sm file:border-0 file:bg-transparent file:font-medium focus-visible:ring-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  );
};
Input.displayName = 'Input';

export { Input };
